import React, { useRef, useState } from 'react';
import { Tooltip } from './Tooltip';

export interface SubtleTooltipProps {
  title?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
  onClick?: () => void;
}

export const SubtleTooltip = ({
  title,
  className,
  children,
  onClick,
}: SubtleTooltipProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);
  const [maxWidth, setMaxWidth] = useState<number>();

  const OVERFLOW_TOLERANCE_PX = 2;

  const isOverflowing = (el: Element) =>
    el.scrollHeight - el.clientHeight >= OVERFLOW_TOLERANCE_PX ||
    el.scrollWidth - el.clientWidth >= OVERFLOW_TOLERANCE_PX;

  const handleMouseEnter = () => {
    const el = ref.current;
    if (!el) return;
    setIsTruncated(
      [el, ...Array.from(el.querySelectorAll('*'))].some(isOverflowing)
    );

    setMaxWidth(el.offsetWidth);
  };

  return (
    <Tooltip
      title={isTruncated ? title : ''}
      rootClassName={'subtle-tooltip'}
      overlayStyle={{ maxWidth }}
    >
      <div
        ref={ref}
        className={className}
        onClick={onClick}
        onMouseEnter={handleMouseEnter}
      >
        {children}
      </div>
    </Tooltip>
  );
};
